export const name = 'gzOuterContainer';
export default function gzOuterContainer($log) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  var directive = {
    restrict: 'EA',
    transclude: true,
    replace: true,
    template: '<ng-transclude></ng-transclude>',
    link: gzOuterContainerLink
  };

  return directive;


  /////////////////
  // private functions

  function gzOuterContainerLink(scope, element, attrs) {
    // $log.debug('found a gz-outer-container!');
  }

} //gzOuterContainer
